import { Brand, BrandsResponse, RecommendedKeyword, RecommendedKeywordsResponse, SearchResponse } from '../types/searchType';
import apiClient from './apiClient';

export const fetchBrands = async (): Promise<Brand[]> => {
  try {
    const response = await apiClient.get<BrandsResponse>('/search/brands/');
    return response.data.data;
  } catch (error) {
    console.error('Error fetching brands:', error);
    throw error;
  }
};

export const fetchRecommendedKeywords = async (): Promise<RecommendedKeyword[]> => {
  try {
    const response = await apiClient.get<RecommendedKeywordsResponse>('/search/keywords/recommended/');
    if (response.data && Array.isArray(response.data.data)) {
      return response.data.data;
    } else {
      console.error('Unexpected API response structure:', response.data);
      return [];
    }
  } catch (error) {
    console.error('Error fetching recommended keywords:', error);
    throw error;
  }
};



// Add this new function to perform the search
export const performSearch = async (query: string): Promise<SearchResponse> => {
  try {
    const response = await apiClient.get<SearchResponse>(`/search/query/${encodeURIComponent(query)}`);
    
    return response.data;
  } catch (error) {
    console.error('Error performing search:', error);
    throw error;
  }
};
